<template>
  <div class="page-container">
    <i class="fas fa-robot fa-7x sad-robot"></i>

    <section class="sub-text">
      <p>
        Unfortunately Teleportal is currently unavailable on mobile devices.
      </p>
      <p>
        Please
        <strong>open this website on your Desktop PC or Laptop</strong> to
        control robots.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "Mobile"
};
</script>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;
}

.sad-robot {
  color: #42b983;
  margin: 40px;
}

.sub-text {
  color: rgb(79, 79, 85);
  font-family: "Questrial", sans-serif;
  font-size: 1em;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.125px;
  margin: 15px;
}
</style>
